import axios from '../localAxios';
import { v3QuizURL } from './url';

export type CreateQuizParameter = {
  parentId: number;
};

export type CreateQuizResponse = {
  socNumber: string;
};

export async function createQuiz(createQuizParameter: CreateQuizParameter) {
  const url = v3QuizURL();
  const result = await axios.post<CreateQuizResponse>(
    url.href,
    createQuizParameter
  );
  return result.data;
}
